<script setup>
/* Props */
const props = defineProps({
  showKicker: {
    type: Boolean,
    default: false,
  },
  kickerText: {
    type: String,
    default: '',
  },
  kickerTextNoStyling: {
    type: String,
    default: '',
  },
  kickerIsDiscontinued: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <g-kicker
    v-if="props.showKicker"
    class="kicker__container"
    :text="props.kickerTextNoStyling"
    :additional-text="props.kickerText"
    :alt-color="props.kickerIsDiscontinued"
  />
</template>

<style lang="scss" scoped>
:deep(.g__kicker) {
  margin-inline-end: $spacing-sm;
}

:deep(.g__kicker__additional-text) {
  font-size: $font-size-small;
}

.kicker__container:not(:empty) {
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
</style>
